import _defineProperty from '@babel/runtime/helpers/defineProperty';
import '../../../../../util/styles/index.js';
import { useOption } from '@react-aria/listbox';
import { mergeProps } from '@react-aria/utils';
import { useSelectionListBoxContext } from '../../../hooks/useSelectionListBoxContext.js';
import { useAdsStyles } from '../../../../../util/styles/hooks/useAdsStyles.js';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var useSelectionListItem = function useSelectionListItem(props, ref) {
  var state = props.state,
    item = props.item,
    virtualizedProps = props.virtualizedProps;
  var rendered = item.rendered,
    key = item.key;
  var _useSelectionListBoxC = useSelectionListBoxContext(),
    selectionMode = _useSelectionListBoxC.selectionMode,
    isVirtualized = _useSelectionListBoxC.isVirtualized;
  var _useReactAriaOption = useOption({
      key: key
    }, state, ref),
    optionProps = _useReactAriaOption.optionProps,
    isSelected = _useReactAriaOption.isSelected,
    isDisabled = _useReactAriaOption.isDisabled,
    isFocusVisible = _useReactAriaOption.isFocusVisible;
  var _useAdsStyles = useAdsStyles(),
    mapAdsStyles = _useAdsStyles.mapAdsStyles,
    getInteractiveState = _useAdsStyles.getInteractiveState;
  var itemProps = {
    'data-focus': isFocusVisible ? 'true' : undefined
  };
  var virtualizerStyle = isVirtualized && virtualizedProps && {
    position: 'absolute',
    top: 0,
    width: '100%',
    height: "".concat(virtualizedProps === null || virtualizedProps === void 0 ? void 0 : virtualizedProps.size, "px"),
    transform: "translateY(".concat(virtualizedProps === null || virtualizedProps === void 0 ? void 0 : virtualizedProps.start, "px)")
  };
  var listItemStyle = mapAdsStyles(_objectSpread({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    px: '4',
    py: '8',
    gap: '8',
    borderRadius: {
      value: '4'
    },
    minHeight: '40px',
    cursor: isDisabled ? 'not-allowed' : 'auto'
  }, isVirtualized && virtualizerStyle));
  var interactiveStateStyles = isDisabled ? {} : getInteractiveState({
    type: 'filled'
  }).adsStyles;
  return {
    ref: ref,
    rendered: rendered,
    isSelected: isSelected,
    isDisabled: isDisabled,
    isFocusVisible: isFocusVisible,
    selectionMode: selectionMode,
    listItemProps: mergeProps(itemProps, optionProps, interactiveStateStyles, listItemStyle)
  };
};

export { useSelectionListItem };
//# sourceMappingURL=useSelectionListItem.js.map
